"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectionValue = exports.getIsSyncFailed = exports.getSfCampaignLink = exports.getIsCampaignConnected = exports.getCampaignConnectionIsLoading = void 0;

var _reselect = require("reselect");

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _connectToSF = require("./connectToSF.types");

var pathToConnectSFState = function pathToConnectSFState(state) {
  return state.modules.campaignSettings.connectToSF;
};

var getCampaignConnectionIsLoading = (0, _ramda.pipe)(pathToConnectSFState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getCampaignConnectionIsLoading = getCampaignConnectionIsLoading;
var getIsCampaignConnected = (0, _ramda.pipe)(pathToConnectSFState, function (state) {
  return state.campaignConnectionStatus === _connectToSF.CampaignConnectionStatus.Connected;
});
exports.getIsCampaignConnected = getIsCampaignConnected;
var getSfCampaignLink = (0, _ramda.pipe)(pathToConnectSFState, function (state) {
  return state.sfCampaignUrl;
});
exports.getSfCampaignLink = getSfCampaignLink;
var getIsSyncFailed = (0, _ramda.pipe)(pathToConnectSFState, function (state) {
  return state.status === _utils.StateStatus.Rejected;
});
exports.getIsSyncFailed = getIsSyncFailed;
var getConnectionValue = (0, _reselect.createSelector)(getIsSyncFailed, getIsCampaignConnected, function (isSyncFailed, isConnected) {
  if (isSyncFailed) {
    return _connectToSF.CampaignConnectionValues.SyncFailed;
  }

  return isConnected ? _connectToSF.CampaignConnectionValues.Connected : _connectToSF.CampaignConnectionValues.NotConnected;
});
exports.getConnectionValue = getConnectionValue;